export default "__VITE_ASSET__200a2a7c__"